import ModuleContainer from './components/Container';
import productsDucksConfig from './products/config';

productsDucksConfig();

export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x",
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      'iguazu-rest': '^1.11.1',
      'iguazu-rpc': '^1.6.1',
    },
  });
}
